import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/new/logo-with-text.png")